import { Col as AntCol, Switch as AntSwitch } from 'antd'
import styled, { css } from 'styled-components'
import Text from 'antd/lib/typography/Text'

import { NodeColor } from 'src/components/Tree/Nodes'

export const Col = styled(AntCol)`
  display: flex;
`

export const Description = styled(Text)`
  color: rgba(0, 0, 0, 0.4);
`

const Icon = css`
  border: 1px solid black;
  height: 1rem;
  margin-right: 0.5rem;
  width: 1rem;
`

export const Icon1 = styled.div`
  ${Icon} background-color: ${NodeColor.DISABLED};
`

export const Icon2 = styled.div`
  ${Icon} background-color: ${NodeColor.SELECTED};
`

export const Icon3 = styled.div`
  ${Icon} background-color: ${NodeColor.DEFAULT};
`

export const Switch = styled(AntSwitch)`
  margin-right: 0.5rem;
  width: 4rem;
`

export const TextInfo = styled(Text)`
  font-size: small;
  font-style: italic;
  padding: 1rem 0;
`

export const Title = styled(Text)`
  font-size: medium;
  font-weight: bold;
`
